// Redux slice for the flag-gated New Season editors (state key: new_season_data).
// Holds the V2 tree of ONE farming unit at a time. No V1 reducer reads it, and
// it never touches distribution_data / selected_entities.
const newSeasonDefaults = {
  tree_key: '', // `${distribution_id}/${farming_unit_id}` the tree belongs to
  tree: null,
  tree_status: '', // '' | 'init' | 'success' | 'fail'
  tree_error: '',
  distributions: null, // GET v2/distributions -> distributions[]
  distributions_status: '', // '' | 'init' | 'success' | 'fail'
  distributions_error: '',
};

const newSeasonReducer = (state = newSeasonDefaults, action) => {
  switch (action.type) {
    case 'NEW_SEASON_TREE_INIT':
      return {
        ...state,
        tree_key: action.tree_key,
        // Keep the current tree only while it is the same farming unit's.
        tree: state.tree_key === action.tree_key ? state.tree : null,
        tree_status: 'init',
        tree_error: '',
      };
    case 'NEW_SEASON_TREE_SUCCESS':
      if (action.tree_key !== state.tree_key) {
        return state; // a stale response for a farming unit no longer shown
      }
      return {
        ...state,
        tree: action.tree,
        tree_status: 'success',
        tree_error: '',
      };
    case 'NEW_SEASON_TREE_FAIL':
      if (action.tree_key !== state.tree_key) {
        return state;
      }
      return { ...state, tree_status: 'fail', tree_error: action.error };
    case 'NEW_SEASON_SEASON_SAVED':
      if (action.tree_key !== state.tree_key || !state.tree) {
        return state;
      }
      return { ...state, tree: replaceSeasonInTree(state.tree, action.season) };
    case 'NEW_SEASON_DISTRIBUTIONS_INIT':
      return {
        ...state,
        distributions_status: 'init',
        distributions_error: '',
      };
    case 'NEW_SEASON_DISTRIBUTIONS_SUCCESS':
      return {
        ...state,
        distributions: action.distributions,
        distributions_status: 'success',
        distributions_error: '',
      };
    case 'NEW_SEASON_DISTRIBUTIONS_FAIL':
      return {
        ...state,
        distributions_status: 'fail',
        distributions_error: action.error,
      };
    default:
      return state;
  }
};

const replaceSeasonInTree = (tree, season) => ({
  ...tree,
  field_groups: (tree.field_groups || []).map(fieldGroup => ({
    ...fieldGroup,
    blocks: (fieldGroup.blocks || []).map(block => ({
      ...block,
      seasons: (block.seasons || []).map(current =>
        current.id === season.id ? season : current
      ),
    })),
  })),
});

module.exports = {
  newSeasonDefaults,
  newSeasonReducer,
};
